import React from 'react';

interface ClientStatusBadgeProps {
    isActive: boolean;
    size?: 'sm' | 'md';
}

export const ClientStatusBadge: React.FC<ClientStatusBadgeProps> = ({ isActive }) => {
    const config = isActive
        ? {
            color: 'bg-green-100 text-green-800 border-green-200 dark:bg-green-900/30 dark:text-green-300 dark:border-green-800',
            dot: 'bg-green-600 dark:bg-green-400',
            label: 'Activo',
        }
        : {
            color: 'bg-red-100 text-red-800 border-red-200 dark:bg-red-900/30 dark:text-red-300 dark:border-red-800',
            dot: 'bg-red-600 dark:bg-red-400',
            label: 'Inactivo',
        };

    return (
        <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full border text-xs font-medium ${config.color}`}>
            <span className={`block h-1.5 w-1.5 rounded-full flex-shrink-0 ${config.dot}`} />
            {config.label}
        </span>
    );
};
